import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import Button from 'components/common/Button'
import Icon from 'components/common/Icon'

/** A button with a Pin as an Icon for a "Change Location" button. */
const IconButton = ({ text, icon, ...rest }) => {
  return (
    <Button {...rest}>
      <Icon path={icon} width={16} height={16} />
      <Div width={3} />
      <div>{text}</div>
    </Button>
  )
}

IconButton.propTypes = {
  /** Text to display in the button */
  text: PropTypes.string.isRequired,
  /** Icon to display in the button */
  icon: PropTypes.element.isRequired
}

export default IconButton



// WEBPACK FOOTER //
// ./src/components/common/IconButton.js